import { CustomEventNames, EventTypes } from 'state/amplitude';
import { AllowedEvent } from 'state/amplitude/allowed-events';
import { t } from 'state/intl/translations';

import { PromoCodeError, PromoCodeErrorReason } from './types';

export const createRbiApplyPromoCodeEvent = (
  promoCode: string,
  response: 'Successful' | 'Failed',
  failureReason?: PromoCodeErrorReason
): AllowedEvent => ({
  name: CustomEventNames.ACTION_SHEET_SUBMISSION,
  type: EventTypes.Other,
  attributes: {
    actionSheetHeader: 'Apply Promo Code',
    response,
    failureReason,
    submittedData: promoCode,
  },
});

export const buildErrorMessageFromPromoCodeError = (promoCodeError: PromoCodeError) => {
  switch (promoCodeError.message) {
    case PromoCodeErrorReason.expiredCode:
      return t('promoCodeOfferExpiredCode');
    case PromoCodeErrorReason.redeemedCode:
      return t('promoCodeOfferRedeemedCode');
    default:
      return t('promoCodeOfferInvalidCode');
  }
};
